import { StateSlice } from '@core/state/state-slice';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IEntitiesState } from './entities-state';

export const selectEntityState = createFeatureSelector<IEntitiesState>(StateSlice.ENTITY);

export const getLocationEntities = createSelector(
    selectEntityState,
    (state: IEntitiesState) => state.entities.location
);

export const getInvoicesEntities = createSelector(
    selectEntityState,
    (state: IEntitiesState) =>  state.entities.invoice
);

export const getUserEntities = createSelector(
    selectEntityState,
    (state: IEntitiesState) =>  state.entities.user
);

export const getEmployeeEntities = createSelector(
    selectEntityState,
    (state: IEntitiesState) =>  state.entities.employee
);

export const getEmployeePaystubEntities = createSelector(
    selectEntityState,
    (state: IEntitiesState) =>  state.entities.employeePaystub
);

export const getEmployeeWageEntities = createSelector(
    selectEntityState,
    (state: IEntitiesState) =>  state.entities.employeeWage
);

export const getEmployeeDocumentEntities = createSelector(
    selectEntityState,
    (state: IEntitiesState) =>  state.entities.employeeDocument
);

export const getEmployeeDeductionEntities = createSelector(
    selectEntityState,
    (state: IEntitiesState) =>  state.entities.employeeDeduction
);

export const getEmployeeBenefitEntities = createSelector(
    selectEntityState,
    (state: IEntitiesState) =>  state.entities.employeeBenefit
);

export const getPayrollEntities = createSelector(
    selectEntityState,
    (state: IEntitiesState) =>  state.entities.payroll
);

export const getPayrollPaymentEntities = createSelector(
    selectEntityState,
    (state: IEntitiesState) =>  state.entities.payrollPayment
);

export const getContractorEntities = createSelector(
    selectEntityState,
    (state: IEntitiesState) =>  state.entities.contractor
);

export const getContractorPaystubEntities = createSelector(
    selectEntityState,
    (state: IEntitiesState) =>  state.entities.contractorPayment
);

export const getContractorDocumentEntities = createSelector(
    selectEntityState,
    (state: IEntitiesState) =>  state.entities.contractorDocument
);

// Taxation

export const getTaxationDocumentEntities = createSelector(
    selectEntityState,
    (state: IEntitiesState) =>  state.entities.document
);

export const getTaxationDepositEntities = createSelector(
    selectEntityState,
    (state: IEntitiesState) =>  state.entities.deposit
);

// Workplaces
export const getWorkplaceEntities = createSelector(
    selectEntityState,
    (state: IEntitiesState) =>  state.entities.workplace
);

// Leave Policies
export const getLeavePolicyEntities = createSelector(
    selectEntityState,
    (state: IEntitiesState) =>  state.entities.leavePolicy
);

//Relationships

export const getEmployeePaystubsRelationship = createSelector(
    selectEntityState,
    (state: IEntitiesState) =>  state.relationships.employeePaystubs
);

export const getEmployeeDocumentsRelationship = createSelector(
    selectEntityState,
    (state: IEntitiesState) =>  state.relationships.employeeDocuments
);

export const getEmployeeDeductionsRelationship = createSelector(
    selectEntityState,
    (state: IEntitiesState) =>  state.relationships.employeeDeductions
);

export const getEmployeeBenefitsRelationship = createSelector(
    selectEntityState,
    (state: IEntitiesState) =>  state.relationships.employeeBenefits
);

export const getEmployeeWagesRelationship = createSelector(
    selectEntityState,
    (state: IEntitiesState) =>  state.relationships.employeeWages
);

export const getContractorPaystubsRelationship = createSelector(
    selectEntityState,
    (state: IEntitiesState) =>  state.relationships.contractorPayments
);

export const getContractorDocumentsRelationship = createSelector(
    selectEntityState,
    (state: IEntitiesState) =>  state.relationships.contractorDocuments
);
